module.exports = __webpack_public_path__ + "img/GH-syoukai-top-image001.f4007eb1.webp";